import React, {Component} from 'react';
import '../css/style-archiv.css';
import PropTypes from "prop-types";
import StaticVideoFunctions from "./StaticVideoFunctions";

class VideoContainer extends Component {

    static propTypes = {
        videoId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        videoTitle: '',
        videoLength: '',
        videoSource: 'YouTube',
        content: '',
        status: 'ok',
        videoDisabled: false,
        useBootstrap: true,
    };

    constructor(props) {

        super(props);

    }

    defaultClicked(videoId) {

        alert('This video is not available!');

        return null;

    }

    getOnClickFunction() {

        if (this.props.status === 'ok') {
            if (!this.props.videoDisabled) {
                return this.props.onClick(this.props.videoId);
            } else {
                return this.defaultClicked(this.props.videoId);
            }
        } else {
            alert(this.props.content);
        }

    }

    render() {

        const bootstrapClasses = 'col-xs-12 col-sm-6 col-md-3';
        const containerClasses = ['archivContainer', 'videoContainer', (this.props.useBootstrap) ? bootstrapClasses : '', this.props.classes].join(' ').trim();
        const contentClasses = ['archivContent', (this.props.videoDisabled) ? ' archivDisabled' : ''].join(' ').trim();
        const boxClasses = ['archivBox', 'videoHover', this.props.status, (this.props.videoDisabled) ? ' disabledItem' : ''].join(' ').trim();
        const styles = {backgroundImage: StaticVideoFunctions.getBackgroundImage(this.props.videoId, this.props.videoSource)};

        return (
            <div id={"video-" + this.props.videoId} className={containerClasses}>
                <div className={boxClasses} onClick={() => this.getOnClickFunction()} style={styles}>
                    <div className="archivTitle">{this.props.videoTitle}</div>
                    <div className="archivSub">{this.props.videoLength}</div>
                    <div className={contentClasses}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>{this.props.content}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

}

export default VideoContainer;